import TZapper from '../templates/zapper';
import { channelsSelector } from '../../../shared/store/slices/channels.slice';
import { useAppSelector } from '../../../shared/store/hooks';

export default function Zapper() {
  const { currentChannel } = useAppSelector(channelsSelector);
  return <TZapper currentChannel={currentChannel} />;
}
